/**
 * Utility functions for handling UTM parameters
 */

const UTM_STORAGE_KEY = 'valycode_utm_params';
const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

/**
 * Extracts UTM parameters from URL search params
 * @param {URLSearchParams} searchParams - URL search parameters
 * @returns {Object} Object containing UTM parameters
 */
export function extractUTMParams(searchParams) {
  const utmParams = {};
  
  UTM_PARAMS.forEach(param => {
    const value = searchParams.get(param);
    if (value) {
      utmParams[param] = value;
    }
  });
  
  return utmParams;
}

/**
 * Saves UTM parameters to localStorage
 * @param {Object} utmParams - UTM parameters to save
 */
export function saveUTMParams(utmParams) {
  if (!utmParams || Object.keys(utmParams).length === 0) return;
  
  try {
    localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(utmParams));
  } catch (error) {
    console.warn('Failed to save UTM params:', error);
  }
}

/**
 * Retrieves stored UTM parameters from localStorage
 * @returns {Object} Stored UTM parameters or empty object
 */
export function getStoredUTMParams() {
  try {
    const stored = localStorage.getItem(UTM_STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch (error) {
    console.warn('Failed to retrieve UTM params:', error);
    return {};
  }
}

/**
 * Captures UTM parameters from current URL and stores them
 * Should be called on app initialization
 */
export function captureUTMParams() {
  if (typeof window === 'undefined') return;
  
  const searchParams = new URLSearchParams(window.location.search);
  const utmParams = extractUTMParams(searchParams);
  
  if (Object.keys(utmParams).length > 0) {
    saveUTMParams(utmParams);
  }
}

/**
 * Gets UTM parameters for event tracking
 * Returns stored UTM params or empty object
 * @returns {Object} UTM parameters for tracking
 */
export function getUTMParamsForTracking() {
  return getStoredUTMParams();
}

